import React from 'react';
import './preview-footer.sass';
import LogoFooter from '../../assets/preview/Logo_footer_big.png';
import LogoFooterSmall from '../../assets/preview/Logo_footer_small.png';
import LogoFooterMedium from '../../assets/preview/Logo_footer_mdm.png';
import { Config } from '../../../../config/config';
import { useHistory } from 'react-router-dom';

export const PreviewFooter = () => {

  const history = useHistory();

  return (
    <div className='vv-preview-footer'>
      <div className='vv-preview-footer__container'>
        <div className='vv-preview-footer__link-wrapper'>
          <div className='vv-preview-footer__link-container vv-preview-footer__link-container--with-border'><a
            onClick={() => history.push(Config.routePaths.main.vendor.path)}>Dla partnerow</a></div>
          <div className='vv-preview-footer__link-container'><a href={Config.urls.vvBlog} target='_blank'
                                                                rel='noreferrer'>Blog.Viceversa</a></div>
        </div>
        <div>
          <picture>
            {/*<source media='(min-width: 1250px)' srcSet={LogoFooter}/>*/}
            {/*<source media='(min-width: 500px)' srcSet={LogoFooter}/>*/}
            <img className='vv-preview-footer__image' src={LogoFooterSmall} alt='ViceVersa'/>
          </picture>
        </div>
        <div className='vv-preview-footer__link-wrapper'>
          <div className='vv-preview-footer__link-container vv-preview-footer__link-container--with-border'>
            <a href={Config.urls.googleStoreUrl} target='_blank' rel='noreferrer'>Google Play</a>
            <a href={Config.urls.iosStoreUrl} target='_blank' rel='noreferrer'>App Store</a>
          </div>
          <div className='vv-preview-footer__link-container'>
            <a href={Config.urls.vvFacebook} target='_blank' rel='noreferrer'>Facebook</a>
            <a href={Config.urls.vvInstagram} target='_blank' rel='noreferrer'>Instagram</a>
            <a href={Config.urls.vvTikTok} target='_blank' rel='noreferrer'>Tiktok</a>
          </div>
        </div>
      </div>
    </div>
  );
};
